import { render, staticRenderFns } from "./homeBottom.vue?vue&type=template&id=2c3bb5bc&scoped=true&"
import script from "./homeBottom.vue?vue&type=script&lang=js&"
export * from "./homeBottom.vue?vue&type=script&lang=js&"
import style0 from "./homeBottom.vue?vue&type=style&index=0&id=2c3bb5bc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c3bb5bc",
  null
  
)

export default component.exports